module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group",
    attrs: {
      "id": "gas-station-search"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "id": "gas-station-finder--input",
      "type": "search",
      "placeholder": "Tankstelle suchen (Ort oder PLZ)",
      "aria-label": "Tankstelle suchen",
      "aria-describedby": "search-addon"
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-results"
    }
  }, [_c('div', {
    staticClass: "card-list"
  }, [_c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "staggered"
    }
  }, _vm._l((_vm.methodResults), function(result) {
    return _c('ResultsTemplate', {
      key: result.item.tid,
      attrs: {
        "item": result.item
      },
      on: {
        "item-clicked": function($event) {
          _vm.stationSelected(result.item)
        },
        "click": function($event) {
          _vm.term = ''
        }
      }
    })
  })), _vm._v(" "), _c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "staggered"
    }
  }, _vm._l((_vm.placesResults), function(item) {
    return (!_vm.methodResults.length) ? _c('PlaceResultsTemplate', {
      key: item.place_id,
      attrs: {
        "item": item
      },
      on: {
        "place-clicked": function($event) {
          _vm.placeSelected(item)
        },
        "click": function($event) {
          _vm.term = ''
        }
      }
    }) : _vm._e()
  }))], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text",
    attrs: {
      "id": "search-addon"
    }
  }, [_c('i', {
    staticClass: "icon-gas text-primary"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c90002","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Resources/Private/JavaScript/components/searchWidget/SearchWidget.vue
// module id = 107
// module chunks = 0